var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.531 14.617L20.814 18.899L19.399 20.314L15.117 16.031C13.5237 17.3082 11.542 18.0029 9.5 18C4.532 18 0.5 13.968 0.5 9C0.5 4.032 4.532 0 9.5 0C14.468 0 18.5 4.032 18.5 9C18.5029 11.042 17.8082 13.0237 16.531 14.617ZM14.525 13.875C15.7938 12.5697 16.5025 10.8204 16.5 9C16.5 5.133 13.367 2 9.5 2C5.633 2 2.5 5.133 2.5 9C2.5 12.867 5.633 16 9.5 16C11.3204 16.0025 13.0697 15.2938 14.375 14.025L14.525 13.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d2b537dd91e4dc4fcc4831adf57d584c.svg";
export { ForwardRef as ReactComponent };